import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import "./Modal.css"; // Using the same modal styles

const SetToScreenModal = ({ isOpen, onClose, playlist }) => {
  const [screens, setScreens] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState("");

  useEffect(() => {
    const fetchScreens = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "screens"));
        const screenData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setScreens(screenData);
      } catch (err) {
        console.error("Error fetching screens:", err);
      }
    };

    if (isOpen) {
      fetchScreens();
    }
  }, [isOpen]);

  const handleAssign = async () => {
    if (!selectedScreen) {
      alert("Please select a screen.");
      return;
    }

    try {
      const screenRef = doc(db, "screens", selectedScreen);

      // ✅ Update the `nowPlaying` field on the screen document
      await updateDoc(screenRef, {
        nowPlaying: {
          id: playlist.id,
          name: playlist.name,
          type: "playlist",
        },
      });

      alert(`Playlist "${playlist.name}" assigned to screen ${selectedScreen}`);
      onClose();
    } catch (err) {
      console.error("Error setting playlist to screen:", err.message);
      alert("Failed to assign playlist.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>Set Playlist to Screen</h2>
        <p>Select a screen for "{playlist?.name}"</p>
        <select
          value={selectedScreen}
          onChange={(e) => setSelectedScreen(e.target.value)}
        >
          <option value="">Select a Screen</option>
          {screens.map((screen) => (
            <option key={screen.id} value={screen.id}>
              {screen.name || `Screen ${screen.id}`}
            </option>
          ))}
        </select>
        <div className="modal-actions">
          <button className="btn cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn save" onClick={handleAssign}>
            Assign
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetToScreenModal;
